import React from 'react';
import Loading from 'react-loading-components';
 
const Ex = () => (
  <Loading type='puff' width={100} height={100} fill='#3b5998' />
);
 
export default Ex;
